import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FlyoutService } from '../sign-up-flyout/flyout.service';
import { NgForm } from '@angular/forms';
import { Signup } from '../shared/models/signup';
import { IEmail, LiveUpdateService } from '../shared/live-update.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'ae-sign-up-quote',
  templateUrl: './sign-up-quote.component.html',
  styles: []
})
export class SignUpQuoteComponent implements OnInit {
  @ViewChild('flyout') public flyout: ElementRef;
  public email: IEmail;
  public showFlyout = false;
  public id = 'quote';
  public success = false;
  @ViewChild('quote') public signUp: NgForm;
  public error = false;

  constructor(private render: Renderer2,
    private flyoutService: FlyoutService,
    private liveUpdateService: LiveUpdateService,
    private datePipe: DatePipe) {
    this.email = {
      emailAddress: '',
      firstName: '',
      lastName: '',
      zipCode: '',
      quote: ''
    };
  }

  ngOnInit() {
    this.flyoutService.flyoutId$.subscribe(this.toggleFlyout.bind(this));
  }

  toggleFlyout(id: string) {
    if (id === this.id) {
      if (this.showFlyout) {
        this.success = false;
        this.showFlyout = false;
        this.error = false;
        this.signUp.reset();
        this.render.setStyle(this.flyout.nativeElement, 'width', '0px');
        this.flyoutService.flyoutId.next('');
      } else {
        this.showFlyout = true;
        this.render.setStyle(this.flyout.nativeElement, 'width', '500px');
      }
    } else {
      this.showFlyout = false;
    }
  }

  onSubmit(signUp: NgForm) {
    if (signUp.valid) {
      this.email.date = this.datePipe.transform(new Date(), 'mediumDate');
      this.email.firstName = this.signUp.controls.firstName.value;
      this.email.quote = this.signUp.controls.quote.value;
      this.email.emailAddress = this.signUp.controls.email.value;
      this.email.zipCode = this.signUp.controls.zipCode.value;
      this.email.phone = this.signUp.controls.phone.value;
      this.success = true;
      this.liveUpdateService.createQuote(this.email);
    } else {
      this.error = true;
    }
  }

  closeQuote() {
    this.showFlyout = true;
    this.toggleFlyout(this.id);
  }
 }
